var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.1147C24 17.7118 21.8829 19.829 19.2857 19.829H4.71429C2.11714 19.829 0 17.7118 0 15.1147C0 12.5175 2.11714 10.4004 4.71429 10.4004H7.91143C8.03143 10.4004 8.13429 10.5032 8.13429 10.6232C8.13429 10.7175 8.08286 10.7861 8.00571 10.829C8.00571 10.829 7.78286 10.9747 7.61143 11.1547C7.13143 11.6518 6.85714 12.2861 6.85714 12.9718C6.85714 13.6575 7.12286 14.3004 7.61143 14.789L10.1829 17.3604C10.6714 17.849 11.3143 18.1147 12 18.1147C12.6857 18.1147 13.3286 17.849 13.8171 17.3604L16.3886 14.789C16.8771 14.3004 17.1429 13.6575 17.1429 12.9718C17.1429 12.2861 16.8771 11.6432 16.3886 11.1547C16.2686 11.0347 16.14 10.9318 16.0029 10.8375C15.9943 10.829 15.9857 10.829 15.9771 10.8204C15.9086 10.7775 15.8657 10.709 15.8657 10.6232C15.8657 10.5032 15.9686 10.4004 16.0886 10.4004H19.2857C21.8829 10.4004 24 12.5175 24 15.1147Z",
    fill: "#FFE14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1803 12.3632C14.846 12.029 14.306 12.029 13.9717 12.3632L12.8574 13.4775V5.25753C12.8574 4.7861 12.4717 4.40039 12.0003 4.40039C11.5288 4.40039 11.1431 4.7861 11.1431 5.25753V13.4775L10.0374 12.3718C9.70312 12.0375 9.16312 12.0375 8.82884 12.3718C8.49455 12.7061 8.49455 13.2461 8.82884 13.5804L11.4003 16.1518C11.5631 16.3147 11.7774 16.4004 12.0003 16.4004C12.2231 16.4004 12.4374 16.3147 12.6088 16.1518L15.1803 13.5804C15.5146 13.2461 15.5146 12.6975 15.1803 12.3632Z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ed4628b243e735fd231154410c238f7a.svg";
export { ForwardRef as ReactComponent };